module.exports = __webpack_public_path__ + "img/rodrigo.bd07f916.png";